var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcBadgedCrew = function SvgIcBadgedCrew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0950BD",
    d: "M6.305.673a1 1 0 0 1 1.39 0l.684.661a1 1 0 0 0 .836.272l.942-.134a1 1 0 0 1 1.125.818l.164.937a1 1 0 0 0 .516.71l.84.446a1 1 0 0 1 .43 1.323l-.417.855a1 1 0 0 0 0 .878l.418.855a1 1 0 0 1-.43 1.323l-.84.445a1 1 0 0 0-.517.711l-.164.937a1 1 0 0 1-1.125.818l-.942-.134a1 1 0 0 0-.836.272l-.684.661a1 1 0 0 1-1.39 0l-.684-.661a1 1 0 0 0-.836-.272l-.942.134a1 1 0 0 1-1.125-.818l-.164-.937a1 1 0 0 0-.516-.71l-.84-.446a1 1 0 0 1-.43-1.323l.417-.855a1 1 0 0 0 0-.878l-.418-.855a1 1 0 0 1 .43-1.323l.84-.445a1 1 0 0 0 .517-.711l.164-.937a1 1 0 0 1 1.125-.818l.942.134a1 1 0 0 0 .836-.272z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.49 6.175c-.108-.604-.638-.971-1.363-.971-.972 0-1.615.649-1.615 1.796 0 1.177.652 1.797 1.61 1.797.706 0 1.24-.34 1.367-.926l1.31.005C9.653 8.882 8.684 9.8 7.1 9.8 5.43 9.8 4.2 8.775 4.2 7c0-1.778 1.252-2.8 2.9-2.8 1.439 0 2.524.721 2.7 1.975z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgIcBadgedCrew;